// TODO: make a reusable breakpoint system that can scale.
export const breakpoints = {
  xs: '280px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  mobile: '737px',
  tablet: '1195px',
  desktop: '1195px',
  widescreen: '1440px',
} as const

function up(breakpoint: string) {
  return `@media (min-width: ${breakpoint})`
}
function down(breakpoint: string) {
  return `@media (max-width: ${breakpoint})`
}

const theme = {
  colors: {
    primary: '#4d7ec3',
    primary400: '#49615E',
    primary500: '#193231',
    secondary: '#f2eee2',
    yellowBright: '#FBD979',
    blue: '#89CCD2',
    green: '#27A46A',
    black: '#000',
    white: '#fff',
    grey: '#f5f5f5',
    grey100: '#FAFAFA',
    grey200: '#9c9c9c',
    lightGrey: '#CBDAD6',
    lightPrimary: '#F3FBFB',
    danger: '#EB6157',
    paleYellow: '#FFE5A4',
    greyGreen: '#455B55',
    darkGreen: '#16322B',
    yellowGreen: '#8BA8A0',
    greyGreen1: '#294B44',
    yellowGreen1: '#D2DDA1',
    darkGray: '#313131',
    whiteSmoke: '#F2F2F2',
    darkGray2: '#A4A4A4',
    forestGreen: '#258F5E',
    capeCod: '#2D4640',
    yellowGreen2: '#BFCC95',
    sanFelix: '#09C06B',
    lightRed: '#CF6D58',
    darkGreen1: '#1C3F28',
    lightGreen: '#bde1d4',
    lightGreen2: '#D2DDA2',
    darkGreen2: '#1d312b',
    red: '#ff0105',
    darkGray3: '#3d3d3d',
    bianca: '#fff9f5',
    opal: '#a2ccc8',
    heavyMetal: '#282c2b',
    etherealGreen: '#EFF1EC66',
    obsidianBlack: '#0E0E0F',
    forestMoss: '#021E06',
    pastelGrey: '#c9cece',
    mediumSpringBud: '#d3dc94',
    mercury: '#e5e5e5',
    onyx: '#0e0e0f',
    greyChateau: '#a2a9a9',
    stormDust: '#5b6362',
    silverMist: '#A2A9A9',
    seeShell: '#eff1ec',
    peachy: '#FBBA8C',
    lavender: '#B3BFF9',
    translucentWhite10: '#FFFFFF1A',
    translucentWhite40: '#FFFFFF66',
    translucentWhite50: '#FFFFFF80',
    translucentBlack: '#0000001A',
    etherealGreen2: '#EFF1EC',
    stormySilver: '#A2A9A9',
    peachParfait: '#FFE3B9',
    caramelCream: '#FDD6BA',
    whisperingLilac: '#F5DFF8',
    azureBreeze: '#D8DEFC',
    pistachioCream: '#F0F4D2',
    cottonCandy: '#F1D0F5',
    rose: '#F1D0F5',
    coolGrayish: '#FBFCFA',
    melon100: '#EDF1DE',
    melon400: '#DBE0A7',
    peach300: '#FCCEB8',
    accentHighlight400: '#DAFF9D',
    accentStatus300: '#FFFCED',
    accentStatus500: '#6F6221',
    neutral100: '#F6F1EE',
    neutral200: '#D5D1CE',
    neutral300: '#93908E',
    neutral400: '#504F4F',
    popGreen200: '#E6F7EE',
    popGreen500: '#173E29',
  },
  breakpoints: {
    ...breakpoints,
    down,
    up,
  },
  fonts: {
    greycliff: 'Greycliff CF',
    quincy: 'Quincy CF',
  },
} as const

export type Theme = typeof theme

export default theme
